export default () => ({
  handler: 'relativeUrl',
  data: () => '/bet-builder/fixtures',
});
